import React, { useEffect } from 'react';
import PageLoader from 'components/PageLoader';
import useLogout from 'hooks/ui/useLogout';

const LogoutPage: React.FC = () => {
  const { handleLogout } = useLogout();

  useEffect(() => {
    handleLogout();
  }, []);

  return <PageLoader />;
};

export default LogoutPage;
